import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';
import { TranslatePipe, UrlPipe } from '@spartacus/core';
import { CurrentProductService, OutletDirective } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { ProductDetailOutlets } from 'src/app/model/product-outlets.model';
import { ProductReplacement } from 'src/app/model/product.model';
import { ShimanoUtilMethod } from 'src/app/utility/methods.util';

@Component({
  selector: 'app-product-replacement',
  templateUrl: './product-replacement.component.html',
  styleUrls: ['./product-replacement.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [OutletDirective, MatIcon, MatTooltip, RouterLink, AsyncPipe, TranslatePipe, UrlPipe],
})
export class ProductReplacementComponent {
  outlets = ProductDetailOutlets;

  productReplacement$: Observable<ProductReplacement> = this.currentProductService.getProduct();

  constructor(protected currentProductService: CurrentProductService) {}

  getImageRendition(image: any) {
    let size: string;
    size = ShimanoUtilMethod.imageRendition(44);
    if (image) {
      return image.concat(size);
    } else {
      return false;
    }
  }
}
